/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { KorabCompetenceStats } from './korabCompetenceStats';
import { KorabSkillStats } from './korabSkillStats';

export interface KorabStats { 
    childrenCount: number;
    skills: Array<KorabSkillStats>;
    competences: Array<KorabCompetenceStats>;
    /**
     * Sledované dovednosti (aktuální zaměření) dítěte / třídy.
     */
    watchedSkills: Array<string>;
    /**
     * Sledované kompetence (aktuální zaměření) dítěte / třídy.
     */
    watchedCompetences: Array<string>;
}